/*************************************************/
/* LANGUAGE                                      */
/*************************************************/

export function language() {
  // let languageSelector;
  const languageSelectorSelector = ".language-selector";
  const visibleClass = "language-selector--visible";

  const toggleLanguageSelector = function (
    languageSelector,
    forceClose = false
  ) {
    if (languageSelector != null) {
      if (forceClose) {
        languageSelector.classList.remove(visibleClass);
      } else if (!languageSelector.classList.contains(visibleClass)) {
        languageSelector.classList.add(visibleClass);
      } else {
        languageSelector.classList.remove(visibleClass);
      }
    }
  };

  const init = function () {
    document.addEventListener("click", (e) => {
      if (!e.target.classList.contains("language-selector__current")) {
        const languageSelectors = document.querySelectorAll(languageSelectorSelector);

        if (languageSelectors) {
          languageSelectors.forEach((languageSelector) => {
            toggleLanguageSelector(languageSelector, true);
          });
        }
        return false;
      }

      const languageSelector = e.target.closest(languageSelectorSelector);
      if (languageSelector) {
        toggleLanguageSelector(languageSelector);
      }
    });
  };

  init();
}
